import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterRecargaCreditoView.
 * @extends JetView
 */
export default class FilterRecargaCreditoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for UserId
                            name: 'UserId',
                            type: 'number',
                            id: 'UserId',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for UserId
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for UserId
                            on: {
                                onBlur: function () {
                                    // Event handler for onBlur
                                    if (this.getValue() != '') {
                                        $$('Concessionaire').setValue(''); // Clear Concessionaire
                                        $$('BetShopId').setValue(''); // Clear BetShopId
                                    }
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for Concessionaire
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            label: "<span class='icon-user-secret'></span>" + _('Agente'), // Label for Concessionaire
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for Concessionaire
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for options
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length > 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/AgentListSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            on: {
                                onBlur: function () {
                                    // Event handler for onBlur
                                    if (this.getValue() != '') {
                                        $$('UserId').setValue(''); // Clear UserId
                                        $$('BetShopId').setValue(''); // Clear BetShopId
                                    }
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for BetShopId
                            name: 'BetShopId',
                            minWidth: 200,
                            id: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label for BetShopId
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for BetShopId
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for options
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length > 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            on: {
                                onBlur: function () {
                                    // Event handler for onBlur
                                    if (this.getValue() != '') {
                                        $$('Concessionaire').setValue(''); // Clear Concessionaire
                                        $$('UserId').setValue(''); // Clear UserId
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 250 : 0, // Adjust height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        const datos = {
            // Sample data object
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event for clear button
                                this.getRoot().clear(); // Clear the form
                                $$('formRecargaCredito').hide(); // Hide the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Hotkey for button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event for consult button
                                $$('formRecargaCredito').hide(); // Hide the form
                                const filterdata = this.getRoot().getValues(); // Get form values
                                const vthis = this;
                                if (
                                    (filterdata.Concessionaire !== '' && filterdata.Concessionaire !== undefined) ||
                                    (filterdata.UserId !== '' && filterdata.UserId !== undefined) ||
                                    (filterdata.BetShopId !== '' && filterdata.BetShopId !== undefined)
                                ) {
                                    webix
                                        .ajax()
                                        .get(
                                            devConfig.geturlApi() + '/UserManagement/GetRecargaCreditoAgent',
                                            'Concessionaire=' +
                                                filterdata.Concessionaire +
                                                '&UserId=' +
                                                filterdata.UserId +
                                                '&BetShopId=' +
                                                filterdata.BetShopId,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    text = JSON.parse(text);
                                                    if (text.HasError) {
                                                        // Check for errors in response
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _(
                                                                text.AlertMessage, // Display error message
                                                            ),
                                                        });
                                                    } else {
                                                        vthis.app.callEvent(
                                                            'recargaCredito:data',
                                                            [text.data], // Trigger event with data
                                                        );
                                                        $$('FilterRecargaCredito').hide(); // Hide the filter view
                                                        $$('formRecargaCredito').show(); // Show the form
                                                        $$('back-button').show(); // Show back button
                                                        $$('buttonDeposit').show(); // Show deposit button
                                                    }
                                                },
                                            },
                                        );
                                } else {
                                    webix.message({
                                        text: _('Filtre Mínimo por un campo'), // Error message for minimum filter
                                        type: 'error',
                                        expire: 1000,
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            id: 'FilterRecargaCredito',
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                Email: webix.rules.isEmail, // Validation rule for email
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Check screen width
                $$('grav4').hide(); // Hide element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
